import { RefObject } from 'react'
import { CellContext } from '@tanstack/react-table'
import { ReportsItem } from '@/hooks'
import { ActionsDropdown } from '../ActionsDropdown/ActionsDropdown'

type ActionCellProps = CellContext<ReportsItem, unknown> & {
    containerRef?: RefObject<HTMLDivElement>
}

export const ActionsCell: React.FC<ActionCellProps> = ({
    row,
    containerRef,
}) => {
    if (!('customReportId' in row.original)) {
        return null
    }

    return <ActionsDropdown report={row.original} containerRef={containerRef} />
}
